'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { alertActionRecipe } from './styles/alert-action.styles';
import type { AlertActionPropsInterface } from './types/alert-action.types';

/**
 * @since 10.0.0
 */
export const AlertAction = forwardRef<HTMLDivElement, AlertActionPropsInterface>(
  (props: AlertActionPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(alertActionRecipe, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Alert.Action"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

AlertAction.displayName = 'Alert.Action';
